import React from "react";
import { styled } from "@mui/material/styles";
import Tooltip, { TooltipProps, tooltipClasses } from "@mui/material/Tooltip";
import { Box, Typography } from "@mui/material";

import HelpOutlineRoundedIcon from "@mui/icons-material/HelpOutlineRounded";

import "./CustomToolTip.scss";

const HtmlTooltip = styled(
  (
    { className, ...props }: TooltipProps,
    hideHeader: boolean = false,
    headerTitle: string = ""
  ) => <Tooltip {...props} classes={{ popper: className }} arrow />
)(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "rgb(65, 77, 85)",
    color: "#fff",
    maxWidth: 220,
    fontSize: 12,
  },
}));

export default function CustomTooltip(props: any) {
  return (
    <HtmlTooltip
      title={
        <React.Fragment>
          <Box sx={{margin:1}}>
            {props.hideHeader === false && (
              <Typography color="inherit">{props.headerTitle}</Typography>
            )}
            {props.title}
          </Box>
        </React.Fragment>
      }
    >
      <HelpOutlineRoundedIcon className="help-icon" />
    </HtmlTooltip>
  );
}
